import * as React from 'react';

const SvgFacebook = (props) => (
  <svg
    width={20}
    height={20}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle cx={10} cy={10} r={8.75} fill='url(#Facebook_svg__a)' />
    <path
      d='m13.259 12.676.388-2.47h-2.431V8.604c0-.675.339-1.335 1.428-1.335h1.106V5.167S12.747 5 11.788 5C9.784 5 8.476 6.183 8.476 8.324v1.882H6.25v2.47h2.226v5.97a9.048 9.048 0 0 0 2.74 0v-5.97h2.043Z'
      fill='#fff'
    />
    <defs>
      <linearGradient
        id='Facebook_svg__a'
        x1={10}
        y1={1.25}
        x2={10}
        y2={18.698}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#18ACFE' />
        <stop offset={1} stopColor='#0163E0' />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgFacebook;
